
import Vue from "vue";
import { email, required } from "vuelidate/lib/validators";

import { MemberRole } from "../models/Member";

export default Vue.extend({
  data() {
    return {
      role: "",
      email: "",
      existingUser: null as { id: number; name: string; role: string } | null,
      isCheckingEmail: false,
      isNewUser: false,
      emailCheckError: null as string | null,
    };
  },
  validations: {
    email: { required, email },
    role: { required },
    validationGroup: ["email", "role"],
  },
  computed: {
    roles() {
      return [MemberRole.OWNER, MemberRole.OWNER_RVS, MemberRole.MEMBER, MemberRole.SUPERMEMBER];
    },
    emailError() {
      return this.$v.email.$error ? "Email is required or invalid." : "";
    },
    roleError() {
      return this.$v.role.$error ? "Role is required." : "";
    },
    company() {
      return this.$store.getters.company;
    },
    dialog: {
      get(): boolean {
        return this.$store.state.openMemberFormModal.open;
      },
      set(value: boolean) {
        this.$store.dispatch("openMemberFormModal", {
          ...this.$store.state.openMemberFormModal,
          open: value,
        });
      },
    },
  },
  methods: {
    async onEmailBlur() {
      if (!this.$v.email.required || !this.$v.email.email) return;
      this.emailCheckError = null;
      this.existingUser = null;
      this.isNewUser = false;
      this.isCheckingEmail = true;
      try {
        const result = await (this as any).$dep.manageMemberService.checkMemberEmail(this.email);
        if (result.exists) {
          if (result.role === "admin") {
            this.emailCheckError = "Admin users cannot be invited to a company.";
          } else if ((result.company_ids as number[]).includes(Number(this.$route?.params?.id))) {
            this.emailCheckError = "This user is already in this company.";
          } else {
            this.existingUser = result;
            this.role = result.role;
          }
        } else {
          this.isNewUser = true;
        }
      } catch {
        // silent — allow invite to proceed if check fails
      } finally {
        this.isCheckingEmail = false;
      }
    },
    async invite() {
      this.$v.$touch();
      if (this.$v.$invalid) return;

      this.$v.$reset();
      this.$emit("invite", {
        role: this.role,
        email: this.email,
      });

      this.dialog = false;
    },
    close() {
      this.$v.$reset();
      this.$emit("close");
    },
  },
  watch: {
    dialog() {
      if (this.dialog) {
        this.email = "";
        this.role = "";
        this.existingUser = null;
        this.isCheckingEmail = false;
        this.isNewUser = false;
        this.emailCheckError = null;
      }
    },
    email() {
      this.existingUser = null;
      this.isNewUser = false;
      this.emailCheckError = null;
    },
  },
});
